<ngx-charts-chart [view]="[width, height]"
  [showLegend]="false"
  [legendOptions]="legendOptions"
  [activeEntries]="activeEntries"
  [animations]="animations"
  (legendLabelActivate)="onActivate($event, undefined!, true)"
  (legendLabelDeactivate)="onDeactivate($event, undefined!, true)"
  (legendLabelClick)="onClick($event)">
  <svg:g [attr.transform]="transform" class="bar-chart chart">
    <svg:g ngx-charts-grid-panel-series
      [xScale]="groupScale"
      [yScale]="valueScale"
      [data]="results"
      [dims]="dims"
      [orient]="barOrientation.Vertical"></svg:g>
      @if (xAxis) {
        <svg:g ngx-charts-x-axis
          [xScale]="groupScale"
          [dims]="dims"
          [showLabel]="showXAxisLabel"
          [labelText]="xAxisLabel"
          [trimTicks]="trimXAxisTicks"
          [rotateTicks]="rotateXAxisTicks"
          [maxTickLength]="maxXAxisTickLength"
          [tickFormatting]="xAxisTickFormatting"
          [ticks]="xAxisTicks"
          [xAxisOffset]="dataLabelMaxHeight.negative"
          (dimensionsChanged)="updateXAxisHeight($event)"></svg:g>
        }
        @if (yAxis) {
          <svg:g ngx-charts-y-axis
            [yScale]="valueScale"
            [dims]="dims"
            [showGridLines]="showGridLines"
            [showLabel]="showYAxisLabel"
            [labelText]="yAxisLabel"
            [trimTicks]="trimYAxisTicks"
            [maxTickLength]="maxYAxisTickLength"
            [tickFormatting]="yAxisFormat"
            [ticks]="yAxisTicks"
            (dimensionsChanged)="updateYAxisWidth($event)"></svg:g>
          }
          <svg:g>
            <svg:g kilowant-charts-series-vertical
              [prefix]="prefix"
              [pos]="1"
              [attr.transform]="groupTransform(group)"
              [activeEntries]="activeEntries"
              [astericsPositions]="astericsPositions"
              [xScale]="innerScale"
              [yScale]="valueScale"
              [colors]="colorHelper"
              [series]="getSeries()"
              [dims]="dims"
              [gradient]="gradient"
              [tooltipDisabled]="tooltipDisabled"
              [tooltipTemplate]="tooltipTemplate"
              [showDataLabel]="showDataLabel"
              [dataLabelFormatting]="dataLabelFormatting"
              [showkWh]="false"
              [seriesName]="group.name"
              [roundEdges]="roundEdges"
              [animations]="false"
              [noBarWhenZero]="noBarWhenZero"
              (select)="onClick($event, group)"
              (activate)="onActivate($event, group)"
              (deactivate)="onDeactivate($event, group)"
              (dataLabelHeightChanged)="onDataLabelMaxHeightChanged($event, 0)" />
              </svg:g>

              <filter filterUnits="userSpaceOnUse" id="gblur">
                <feGaussianBlur in="src" stdDeviation="0" result="noblur"></feGaussianBlur>
                <feColorMatrix in="src" result="white" type="matrix"
                           values="0 0 0 0 1
                             0 0 0 0 1
                             0 0 0 0 1
                             0 0 0 1 0" />
                  <feGaussianBlur stdDeviation="1" in="white" result="blur1"></feGaussianBlur>
                  <feGaussianBlur stdDeviation="2" in="white" result="blur2"></feGaussianBlur>
                  <feGaussianBlur stdDeviation="3" in="white" result="blur3"></feGaussianBlur>
                  <feGaussianBlur stdDeviation="4" in="white" result="blur4"></feGaussianBlur>
                  <feGaussianBlur stdDeviation="5" in="white" result="blur5"></feGaussianBlur>
                  <feMerge>
                    <feMergeNode in="blur1"></feMergeNode>
                    <feMergeNode in="blur2"></feMergeNode>
                    <feMergeNode in="blur3"></feMergeNode>
                    <feMergeNode in="blur4"></feMergeNode>
                    <feMergeNode in="blur5"></feMergeNode>
                    <feMergeNode in="noblur"></feMergeNode>
                  </feMerge>
                </filter>
                </svg:g>
              </ngx-charts-chart>